import { useCallback } from "react";
import { usePmsTheme } from "../../Components/PmsThemeContext";
import { itemCatalogText } from "./itemCatalogMessages";
import useItemDialogFocus from "./useItemDialogFocus";
import "../PurchasingUi.css";
import "./ItemCatalog.css";

export default function ItemExcelOptionsPopup({ isOpen, onClose, onDownload, onUpload, downloading, error }) {
  const { themeId, languageId } = usePmsTheme();
  const t = useCallback((text) => itemCatalogText(languageId, text), [languageId]);
  const modalRef = useItemDialogFocus(isOpen, downloading, onClose);
  if (!isOpen) return null;
  return (
    <div className="pilcore-purchasing-overlay pu-item-dialog spx-modalBackdrop" data-theme={themeId}
      onClick={(event) => { if (!downloading && event.target === event.currentTarget) onClose(); }}>
      <div ref={modalRef} tabIndex={-1} className="spx-modal ifm-excelOptions" role="dialog" aria-modal="true" aria-label={t("Excel options")}>
        <div className="spx-modalHeader">
          <div>
            <div className="spx-modalKicker">{t("Catalog Import")}</div>
            <h3 className="spx-modalTitle">{t("Excel options")}</h3>
            <p className="spx-modalSubtitle">{t("Download the template, fill in the Items sheet and upload your file.")}</p>
          </div>
          <button type="button" className="spx-closeBtn" onClick={onClose} disabled={downloading} aria-label={t("Close Excel options")}>×</button>
        </div>
        <div className="spx-modalBody">
          <div className="ifm-excelChoices">
            <button type="button" className="spx-btn ifm-excelChoice" onClick={onDownload} disabled={downloading}>
              <strong>{t(downloading ? "Preparing template..." : "Download template")}</strong>
              <span>{t("Excel with the allowed families, subfamilies, categories, subcategories, suppliers and units for this business unit.")}</span>
            </button>
            <button type="button" className="spx-btn ifm-excelChoice" onClick={onUpload} disabled={downloading}>
              <strong>{t("Upload Excel/CSV")}</strong>
              <span>{t("Preview the completed file before confirming the import.")}</span>
            </button>
          </div>
          <p className="spx-note">{t("Use the IDs from the References sheet. Invalid values or incompatible classifications reject the entire file; no items are saved.")}</p>
          {error && <div className="spx-alert" role="alert">{t(error)}</div>}
          <div className="spx-modalFooter"><button type="button" className="spx-btn" onClick={onClose} disabled={downloading}>{t("Cancel")}</button></div>
        </div>
      </div>
    </div>
  );
}
